import { AsyncPipe, NgFor } from '@angular/common';
import { Component, inject } from '@angular/core';
import { map } from 'rxjs';
import { ScreenViewModule } from '@core/directives/screen-view/_screen-view.module';
import { Link } from '@core/models/atomics.model';
import { DEVICE_SIZE } from '@core/models/deviceSize.model';
import { DeviceService } from '@shared/tools/device.service';
import { LinkComponent } from '@shared/components/link/link.component';
import { CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';
import { AbstractLinesComponent } from '@b2b/components/cms/sections/cx-header-section/components/header-mobile/abstract-lines/abstract-lines.component';

@Component({
  selector: 'cx-auxiliary-links',
  imports: [AsyncPipe, NgFor, ScreenViewModule, LinkComponent, AbstractLinesComponent],
  templateUrl: './cx-auxiliary-links.component.html',
  styleUrl: './cx-auxiliary-links.component.scss',
})
export class CxAuxiliaryLinksComponent {
  protected DEVICE_SIZE = DEVICE_SIZE;
  protected data = inject<{ items: Link[] }>(CX_ABSTRACT_COMPONENT_DATA);
  protected deviceService = inject(DeviceService);
  protected availableLinks$ = this.deviceService.onResize$.pipe(
    map(() => {
      return this.data.items.filter(item => {
        if (item.deviceType === 'BOTH') return true;
        if (this.deviceService.isScreenSizeAtLeast(DEVICE_SIZE.DESKTOP)) {
          return item.deviceType === 'DESKTOP';
        }
        return item.deviceType === 'MOBILE';
      });
    }),
  );
}
